function roundPercent(percent) {
  return Math.round(percent * 10) / 10
}

function getPercent(currentCount, maxCount) {
  if (currentCount == null || maxCount == null || maxCount === 0) {
    return '?'
  }

  return roundPercent((currentCount / maxCount) * 100)
}

export default getPercent
